import { render } from "./user_card.vue?vue&type=template&id=22db580c"
import script from "./user_card.js?vue&type=script&lang=js&external"
export * from "./user_card.js?vue&type=script&lang=js&external"

import "./user_card.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__